import {ProvisionMessageSeverity} from '../enum/provision-message-severity.enum';

/**
 * How ONE ProvisionMessageSeverity is presented. Backs KPI K-13 ("Offene Meldungen", 01 §6) on the
 * dashboard start page and the two message tabs of the run detail (04 §5.3) — both message
 * entities (ProvisionContractRunMessage and ProvisionRunMessage) share this severity enum, so they
 * share this table.
 */
export interface ProvisionMessageSeverityPresentation {
    label: string;
    icon: string;
    text: string;
    background: string;
}

export const PROVISION_MESSAGE_SEVERITY_PRESENTATION: { [severity: number]: ProvisionMessageSeverityPresentation } = {
    [ProvisionMessageSeverity.INFO]: {label: 'Information', icon: 'fa-solid fa-circle-info', text: 'text-blue-800', background: 'bg-blue-100'},
    [ProvisionMessageSeverity.WARNING]: {label: 'Warnung', icon: 'fa-solid fa-triangle-exclamation', text: 'text-orange-800', background: 'bg-orange-100'},
    [ProvisionMessageSeverity.ERROR]: {label: 'Fehler', icon: 'fa-solid fa-circle-exclamation', text: 'text-red-800', background: 'bg-red-100'}
};

/** Most severe first — a dashboard chip row is read left to right. */
export const PROVISION_MESSAGE_SEVERITY_DISPLAY_ORDER: ProvisionMessageSeverity[] = [
    ProvisionMessageSeverity.ERROR,
    ProvisionMessageSeverity.WARNING,
    ProvisionMessageSeverity.INFO
];

export const PROVISION_MESSAGE_SEVERITY_UNKNOWN: ProvisionMessageSeverityPresentation = {
    label: 'Unbekannt', icon: 'fa-solid fa-question', text: 'text-700', background: 'bg-100'
};

export function provisionMessageSeverityPresentation(severity: number | undefined | null): ProvisionMessageSeverityPresentation {
    if (severity == null) {
        return PROVISION_MESSAGE_SEVERITY_UNKNOWN;
    }
    return PROVISION_MESSAGE_SEVERITY_PRESENTATION[severity] || PROVISION_MESSAGE_SEVERITY_UNKNOWN;
}
